import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'
import constants from '@/configuration/constants'

const getGateways = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'gateways'), params)
}

const createGateway = (application, eui, params = {}) => {
  return clientHTTP.put(getLinkHref(application, 'gateways') + `/${eui}`, params)
}

const getGateway = (application, eui) => {
  return clientHTTP.get(getLinkHref(application, 'gateways') + `/${eui}`)
}

const patchGateway = (gateway, params = {}, options = {}) => {
  return clientHTTP.patch(getLinkHref(gateway, 'self'), params, {}, options)
}

const deleteGateway = (gateway) => {
  return clientHTTP.delete(getLinkHref(gateway, 'self'))
}

const createGatewaysDeletion = (application, equipments, headers = {}) => {
  return clientHTTP.post(getLinkHref(application, 'createGatewaysDeletion'), equipments, headers)
}

const getGatewaysDeletion = (proccessingUrl) => {
  return clientHTTP.get(constants.gmsUrl + proccessingUrl)
}

const getGatewayBrands = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'brands'), params)
}

/**
 * OVERVIEW
 */

const getGatewayLastEvents = (gateway, params = {}) => {
  return clientHTTP.get(getLinkHref(gateway, 'gatewayLastEvents'), params)
}

const getRncGatewaysLastEvents = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'rncGatewaysLastEvents'), params)
}

const getGatewayLastStatistics = (gateway, params = {}) => {
  return clientHTTP.get(getLinkHref(gateway, 'gatewayLastStatistics'), params)
}

const getGatewayLastConnection = (gateway) => {
  return clientHTTP.get(getLinkHref(gateway, 'gatewayLastConnection'))
}

const getGatewayModems = (gateway, options = {}) => {
  return clientHTTP.getAsync(getLinkHref(gateway, 'gatewayModems'))
}

/**
 * CONFIGURATION
 */

const getGatewayControl = (gateway, options = {}) => {
  return clientHTTP.getAsync(getLinkHref(gateway, 'gatewayControl'), {}, {}, options)
}

const updateGatewayControl = (gateway, params = {}) => {
  return clientHTTP.patchAsync(getLinkHref(gateway, 'gatewayControl'), params)
}

const getGatewayCurrentConfiguration = (gateway, params = {}) => {
  return clientHTTP.getAsync(getLinkHref(gateway, 'gatewayCurrentConfiguration'), params)
}

const updateGatewayCurrentConfiguration = (gateway, params = {}) => {
  return clientHTTP.patchAsync(getLinkHref(gateway, 'gatewayCurrentConfiguration'), params)
}

const getGatewayManagement = (gateway) => {
  return clientHTTP.getAsync(getLinkHref(gateway, 'gatewayManagement'))
}

const updateGatewayManagement = (gateway, params = {}, options = {}) => {
  return clientHTTP.putAsync(getLinkHref(gateway, 'gatewayManagement'), params, {}, options)
}

const getGatewayVersions = (gateway, params = {}) => {
  return clientHTTP.getAll(getLinkHref(gateway, 'gatewayVersions'), params)
}

const getGatewayCurrentVersions = (gateway) => {
  return clientHTTP.getAsync(getLinkHref(gateway, 'gatewayCurrentVersion'))
}

const getGatewayConfigurations = (gateway) => {
  return clientHTTP.getAll(getLinkHref(gateway, 'gatewayConfigurations'))
}

const putLnsGatewayAesKey = (gateway, index, params = {}) => {
  return clientHTTP.put(getLinkHref(gateway, 'lnsGatewayAesKeys') + `/${index}`, params)
}

const deleteLnsGatewayAesKey = (gateway, index) => {
  return clientHTTP.delete(getLinkHref(gateway, 'lnsGatewayAesKeys') + `/${index}`)
}

/**
 * DATA
 */

const getGatewayDataUp = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'dataUp'), params)
}

const getGatewayDataDown = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'dataDown'), params)
}

/**
 * REMOTE COMMAND
 */

const createGatewayCommand = (gateway, command) => {
  return clientHTTP.postAsync(getLinkHref(gateway, 'createGatewayCommand') + `?command=${command}`)
}

/**
 * FILE EXPLORER
 */

const getDirectory = (gateway, directory) => {
  return clientHTTP.postAsync(getLinkHref(gateway, 'createGatewayLsCommand') + '?directory=' + directory)
}

const getFile = (gateway, path) => {
  return clientHTTP
    .postAsync(
      getLinkHref(gateway, 'createGatewayGetFileCommand') + '?filePath=' + path,
      null,
      {},
      // To get a binary file
      { responseType: 'arraybuffer' }
    )
}

const uploadFile = (gateway, file, filename, directory) => {
  return clientHTTP
    .postAsync(
      getLinkHref(gateway, 'createGatewayPutFileCommand') + `?file=${filename}&destinationPath=${directory}`,
      file
    )
}

const createNewFolder = (gateway, directoryPath) => {
  return clientHTTP.postAsync(getLinkHref(gateway, 'createGatewayMkDirCommand') + '?directory=' + directoryPath)
}

const move = (gateway, source, destination) => {
  return clientHTTP.postAsync(getLinkHref(gateway, 'createGatewayMvCommand') + `?source=${source}&destination=${destination}`)
}

const paste = (gateway, source, destination) => {
  return clientHTTP.postAsync(getLinkHref(gateway, 'createGatewayCpCommand') + `?source=${source}&destination=${destination}`)
}

const remove = (gateway, file) => {
  return clientHTTP.postAsync(getLinkHref(gateway, 'createGatewayRmCommand') + `?file=${file}`)
}

/**
 * SPECTRUM
 */

const getSpectrums = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'spectrums'), params)
}

const getSpectrum = (application, spectrumId) => {
  return clientHTTP.get(getLinkHref(application, 'spectrums') + `/${spectrumId}`)
}

const getSpectrumFile = (spectrum, params = {}) => {
  return clientHTTP.get(getLinkHref(spectrum, 'spectrumFile'), params)
}

const deleteSpectrum = (spectrum) => {
  return clientHTTP.delete(getLinkHref(spectrum, 'self'))
}

const createGatewayModemSpectrum = (modem, duration) => {
  return clientHTTP.post(getLinkHref(modem, 'createGatewayModemSpectrum') + `?duration=${duration}&modemSerialNumber=${modem.serialNumber}`)
}

/**
 * DIAGNOSTIC
 */

const getGatewayEvents = (gateway, params = {}) => {
  return clientHTTP.get(getLinkHref(gateway, 'gatewayEvents'), params)
}

const getRncGatewaysEvents = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'rncGatewaysEvents'), params)
}

const getGatewaySnmpLogs = (gateway, params = {}) => {
  return clientHTTP.get(getLinkHref(gateway, 'gatewaySnmpLogs'), params)
}

const getTasks = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'tasks'), params)
}

const getTaskMessages = (task) => {
  return clientHTTP.getAll(getLinkHref(task, 'taskMessages'))
}

const getTaskSnmpLogs = (task) => {
  return clientHTTP.getAll(getLinkHref(task, 'taskSnmpLogs'))
}

/**
 * BSCHELPER
 */
const startBSCC = (application, eui, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'gateways') + `/${eui}/bscHelper/start`, params)
}


export default {
  getGateways,
  createGateway,
  getGateway,
  patchGateway,
  deleteGateway,
  createGatewaysDeletion,
  getGatewaysDeletion,
  getGatewayBrands,
  // OVERVIEW
  getGatewayLastEvents,
  getRncGatewaysLastEvents,
  getGatewayLastStatistics,
  getGatewayLastConnection,
  getGatewayModems,
  // CONFIGURATION
  getGatewayControl,
  updateGatewayControl,
  getGatewayCurrentConfiguration,
  updateGatewayCurrentConfiguration,
  getGatewayManagement,
  updateGatewayManagement,
  getGatewayVersions,
  getGatewayCurrentVersions,
  getGatewayConfigurations,
  putLnsGatewayAesKey,
  deleteLnsGatewayAesKey,
  // DATA
  getGatewayDataUp,
  getGatewayDataDown,
  // REMOTE COMMAND
  createGatewayCommand,
  // FILE EXPLORER
  getDirectory,
  getFile,
  uploadFile,
  createNewFolder,
  move,
  paste,
  remove,
  // SPECTRUM
  getSpectrums,
  getSpectrum,
  getSpectrumFile,
  deleteSpectrum,
  createGatewayModemSpectrum,
  // DIAGNOSTIC
  getGatewayEvents,
  getRncGatewaysEvents,
  getGatewaySnmpLogs,
  getTasks,
  getTaskMessages,
  getTaskSnmpLogs,
  //BSCCHELPER
  startBSCC
}
